import { render } from "./long-insure-report-detail.vue?vue&type=template&id=7a408d0c&scoped=true&ts=true"
import script from "./long-insure-report-detail.vue?vue&type=script&lang=ts"
export * from "./long-insure-report-detail.vue?vue&type=script&lang=ts"

import "./long-insure-report-detail.vue?vue&type=style&index=0&id=7a408d0c&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a408d0c"]])

export default __exports__